module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cateringCreate-page"
  }, [_c('topNav', {
    attrs: {
      "title": _vm.$t('cateringCreate_title'),
      "selfMethod": 1
    },
    on: {
      "leftClick": _vm.goBack
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "basic-user-info"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('cateringCreate_workstation')) + " "), _c('i', {
    staticClass: "must"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "parent"
  }, [_c('gpicker', {
    ref: "pccode",
    on: {
      "change": _vm.changePccode
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('cateringCreate_peopleNumber')) + " "), _c('i', {
    staticClass: "must"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDetail.gsts),
      expression: "formDetail.gsts"
    }],
    staticClass: "inp",
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('cateringCreate_peopleNumber_placeholder')
    },
    domProps: {
      "value": (_vm.formDetail.gsts)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formDetail, "gsts", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('cateringCreate_bookDate')) + " "), _c('i', {
    staticClass: "must"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "parent",
    staticStyle: {
      "height": "32px"
    }
  }, [_c('datepicker', {
    ref: "caterDatepicker",
    staticClass: "picker picker-range",
    attrs: {
      "min": _vm.start,
      "max": _vm.end,
      "hideClear": true,
      "range": false
    },
    on: {
      "input": _vm.dpselect
    },
    model: {
      value: (_vm.formDetail.resDate),
      callback: function($$v) {
        _vm.$set(_vm.formDetail, "resDate", $$v)
      },
      expression: "formDetail.resDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('cateringCreate_bookTime')) + " "), _c('i', {
    staticClass: "must"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "parent",
    staticStyle: {
      "height": "32px"
    },
    on: {
      "click": _vm.openPicker
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDetail.arrtime),
      expression: "formDetail.arrtime"
    }],
    staticClass: "eventTimeInput",
    staticStyle: {
      "color": "#000",
      "height": "auto",
      "outline": "none"
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('cateringCreate_bookTime_placeholder'),
      "readonly": ""
    },
    domProps: {
      "value": (_vm.formDetail.arrtime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formDetail, "arrtime", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('mt-datetime-picker', {
    ref: "pickerEventTime",
    attrs: {
      "cancelText": _vm.$t('cancel'),
      "confirmText": _vm.$t('determine'),
      "type": "time"
    },
    on: {
      "confirm": _vm.pickTime
    },
    model: {
      value: (_vm.formDetail.arrtime),
      callback: function($$v) {
        _vm.$set(_vm.formDetail, "arrtime", $$v)
      },
      expression: "formDetail.arrtime"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('cateringCreate_linkman')) + " "), _c('i', {
    staticClass: "must"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDetail.emp),
      expression: "formDetail.emp"
    }],
    staticClass: "inp",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('cateringCreate_linkman_placeholder'),
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.formDetail.emp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formDetail, "emp", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('cateringCreate_phone')) + " "), _c('i', {
    staticClass: "must"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDetail.phone),
      expression: "formDetail.phone"
    }],
    staticClass: "inp",
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('cateringCreate_phone_placeholder'),
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.formDetail.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formDetail, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('cateringCreate_tableType')))]), _vm._v(" "), _c('div', {
    staticClass: "parent"
  }, [_c('gpicker', {
    ref: "tableType",
    on: {
      "change": _vm.changeTableType
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('cateringCreate_tableNo')))]), _vm._v(" "), _c('div', {
    staticClass: "parent"
  }, [_c('gpicker', {
    ref: "tableNo",
    on: {
      "change": _vm.changeTableNo
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('book_salesman')))]), _vm._v(" "), _c('div', {
    staticClass: "parent",
    on: {
      "click": _vm.openSaleSelect
    }
  }, [_c('div', [(_vm.choosedSaleManCode) ? _c('span', [_vm._v("\n                    " + _vm._s(_vm.choosedSaleMan.code) + " -- " + _vm._s(_vm.choosedSaleMan.name) + "\n                  ")]) : _c('span', {
    staticStyle: {
      "color": "#ccc"
    }
  }, [_vm._v("选择销售员")])]), _vm._v(" "), _c('span', {
    staticClass: "iconfont icon-xia"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('cateringDetail_amount')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDetail.standardAmount),
      expression: "formDetail.standardAmount"
    }],
    staticClass: "inp",
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('cateringDetail_amount'),
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.formDetail.standardAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formDetail, "standardAmount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('cateringDetail_standardType')))]), _vm._v(" "), _c('div', {
    staticClass: "parent"
  }, [_c('gpicker', {
    ref: "standardType",
    attrs: {
      "placeholder": _vm.$t('cateringDetail_standardType')
    },
    on: {
      "change": _vm.changeStandardType
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('remark')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formDetail.info),
      expression: "formDetail.info"
    }],
    staticClass: "remark",
    attrs: {
      "cols": "5",
      "placeholder": _vm.$t('placeHolder_Empty')
    },
    domProps: {
      "value": (_vm.formDetail.info)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formDetail, "info", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-fixed-bottom",
    on: {
      "click": _vm.doAddOrder
    }
  }, [_vm._v(_vm._s(_vm.$t('reservation')) + "\n        ")])], 1)]), _vm._v(" "), (_vm.showSaleSelect) ? _c('div', {
    staticClass: "edit-ratecode-modal"
  }, [_c('div', {
    staticClass: "edit-ratecode-modal-container"
  }, [_c('div', {
    staticClass: "edit-ratecode-title"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('book_salesman')) + "\n          "), _c('i', {
    staticClass: "iconfont icon-cuowu",
    on: {
      "click": _vm.closeSaleSelect
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "search-rate-wrap"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('search')) + "："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchSaleMan),
      expression: "searchSaleMan"
    }],
    staticClass: "spe-search",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchSaleMan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchSaleMan = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ratecode-modal-body"
  }, [(_vm.saleManList.length) ? _c('div', {
    staticClass: "right-arr",
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.saleManList), function(item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.searchSaleMan || ((item.code.indexOf(_vm.searchSaleMan) > -1) || (item.name.indexOf(_vm.searchSaleMan) > -1))),
        expression: "!searchSaleMan || ((item.code.indexOf(searchSaleMan) > -1) || (item.name.indexOf(searchSaleMan) > -1))"
      }],
      key: 'saleMan' + index,
      staticClass: "right-item spe",
      class: item.code == _vm.choosedSaleManCode ? 'active' : '',
      on: {
        "click": function($event) {
          return _vm.setCurrentSaleMan(item)
        }
      }
    }, [_vm._v("\n              " + _vm._s(item.code) + " -- " + _vm._s(item.name) + "\n            ")])
  }), 0) : _c('div', {
    staticClass: "right-arr",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "right-item spe no-data"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('nothing')) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "edit-ratecode-footer"
  }, [_c('div', {
    staticClass: "edit-ratecode-btn ratecode-cancel-btn",
    on: {
      "click": _vm.closeSaleSelect
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "edit-ratecode-btn",
    on: {
      "click": _vm.changeSale
    }
  }, [_vm._v(_vm._s(_vm.$t('determine')) + "\n          ")])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-8ea495c0","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/page/catering/cateringCreate.vue
// module id = 1818
// module chunks = 107